<template>
  <div class="table-responsive">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div class="col-sm-12 col-md-12">
      <TableSearch @handleSearch="handleSearch" />
    </div>
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="row" style="height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead class="data-table-bg">
              <tr>
                <th style="cursor: pointer; text-align: left">
                  #
                </th>
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                </th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length !== 0 && this.dataCheck">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                @click="gotodevice(data._id)"
                style="cursor: pointer; text-align: left;"
                :class="{
                  'data-table-bg': index % 2 !== 0,
                }"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ data.column1 }}</td>
                <td>{{ data.column2 }}</td>
                <td>{{ data.column3 }}</td>
                <td>{{ data.column4 }}</td>
                <td>{{ data.column5 }}</td>
                <td>
                  <div class="d-flex col-gap-2">
                    <span
                      v-if="new Date() > new Date(Number(data.startTime))"
                      @click.stop=""
                      class="cursor-default"
                    >
                      <GreenPlayIcon />
                    </span>
                    <span v-else @click.stop="greyPlay(data._id)">
                      <GreyPlayIcon />
                    </span>
                    <span
                      v-if="new Date() > new Date(Number(data.endTime))"
                      @click.stop=""
                      class="cursor-default"
                    >
                      <GreenStopIcon />
                    </span>
                    <span
                      v-else
                      @click.stop="
                        new Date() > new Date(Number(data.startTime)) &&
                          greyStop(data._id)
                      "
                    >
                      <GreyStopIcon />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="this.stats.length !== 0 && !this.dataCheck">
              <tr>
                <td colspan="6">
                  {{ $t("no-search") }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6">
                  {{ $t("no-dev") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Pagination
        :pageCount="pageCount"
        :data="this.stats"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import GreenPlayIcon from "../components/Iconsvg/GreenPlayIcon.vue";
import GreenStopIcon from "../components/Iconsvg/GreenStopIcon.vue";
import GreyStopIcon from "../components/Iconsvg/GreyStopIcon.vue";
import GreyPlayIcon from "../components/Iconsvg/GreyPlayIcon.vue";
import Loading from "vue-loading-overlay";
import tableMixin from "../mixins/tableMixin";
import Pagination from "../components/PaginationNew.vue";
import TableSearch from "../components/TableSearch.vue";

export default {
  name: "DispatchTable",
  props: {
    stats: Array,
  },
  data() {
    return {
      dataCheck: true,
      isLoading: false,
      fullPage: true,
    };
  },
  components: {
    GreenPlayIcon,
    GreenStopIcon,
    GreyStopIcon,
    GreyPlayIcon,
    Loading,
    Pagination,
    TableSearch,
  },
  mixins: [tableMixin],
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        function getDate(date) {
          if (isNaN(date)) return "Not Set";
          return moment(date, "x", true).format("MMM Do YYYY, hh:mm a");
        }
        for (const element of this.stats) {
          this.dataTable.push({
            column1: element.contact.name,
            column2: element.contact.phone,
            column3: getDate(element.startTime),
            column4: getDate(element.endTime),
            column5: moment(element.createdAt, "x", true).format(
              "MMM Do YYYY, hh:mm a"
            ),
            trackingId: element.trackingId,
            startTime: element.startTime,
            endTime: element.endTime,
            _id: element._id,
            // column4: this.stats[i].group,
          });
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters(["lastPageData"]),
    tableColumns() {
      return [
        [this.$t("stat"), "column1"],
        [this.$t("Phone"), "column2"],
        [this.$t("start"), "column3"],
        [this.$t("end"), "column4"],
        [this.$t("date_created", { name: "(°C)" }), "column5"],
        [this.$t("action", { name: "(%)" }), "column6"],
      ];
    },
  },
  methods: {
    ...mapActions([
      "updatePageNumber",
      "startDispatch",
      "getDispatchRecords",
      "completeDispatch",
    ]),
    gotodevice(_id) {
      this.$router.push(`/dispatch/${_id}`);
    },
    greyPlay(id) {
      this.isLoading = true;
      this.startDispatch(id).then(() => {
        this.getDispatchRecords();
        this.isLoading = false;
      });
    },
    greyStop(id) {
      this.isLoading = true;
      this.completeDispatch(id).then(() => {
        this.getDispatchRecords();
        this.isLoading = false;
      });
    },
    doNothing() {
      console.log("clicked");
    },
  },
};
</script>

<style scoped>

th,
td {
  min-width: 120px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"action": "Action",
		"batt": "Battery {name}",
		"date_created": "Date Created",
		"dev-name": "End",
		"dev-tag": "Device",
		"end": "End",
		"entries": "entries",
		"last-seen": "Last Seen",
		"next": "Next",
		"no-dev": "You have no dispatch yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"start": "Start",
		"stat": "Name",
		"temp": "Temperature {name}",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"action": "Acción",
		"batt": "Batería {name}",
		"date_created": "Fecha de creacion",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"end": "Fin",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"start": "comienzo",
		"stat": "Estado",
		"temp": "Temperatura {name}",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"action": "action",
		"batt": "Batterie {name}",
		"date_created": "Date créée",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"end": "Fin",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"start": "Début",
		"stat": "Statut",
		"temp": "Température {name}",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"action": "Hatua",
		"batt": "Betri {name}",
		"date_created": "Tarehe Iliyoundwa",
		"dev-name": "Mwisho",
		"dev-tag": "Kifaa",
		"end": "Mwisho",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"next": "Ifuatayo",
		"no-dev": "Bado huna kutuma",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"start": "Anza",
		"stat": "Jina",
		"temp": "Halijoto {name}",
		"to": "Kwa"
	}
}
</i18n>
